module.exports = __webpack_public_path__ + "img/auto-repair-icon.b03ed4e1.svg";